import React from 'react'
import NewIcon from "../assets/images/NewQuote_B 1.svg";

export default function OutlookSidebar(props: any) {
  return (
    <div className="pt-4 pf-sidebar-block p-0">
    <>
      <span className={props.pagename === "outlook-page" ? "pf-sidebar-menu active " : "pf-sidebar-menu pf-hover-effect show-cursor"}>
        <img src={NewIcon} className={props.pagename === "outlook-page" ? "pf-sidebar-img pf-sidebar-img-active" : "pf-sidebar-img "} alt="" />
        <span className="sidebar-menu-title">Outlook Installation</span>{" "}
      </span>
    </>
  </div>
  )
}
